var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup34(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2152F84B-E2D3-41AD-9B6B-DE06D8DBEDC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "JN-Generation-Letter---Concepts-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Page---PERS-Record-Page-Image-Updated-v1-New-ScrollPERS-Button-view-v2.1-Alt",
    transform: "translate(-647.000000, -235.000000)",
    stroke: "#E46026",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-updated",
    transform: "translate(74.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(575.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5353425,23.4722192 C25.5353425,25.0108493 24.2876712,26.2585205 22.7490411,26.2585205 C21.209863,26.2585205 19.9627397,25.0108493 19.9627397,23.4722192 C19.9627397,21.9330411 21.209863,20.6859178 22.7490411,20.6859178 C24.2876712,20.6859178 25.5353425,21.9330411 25.5353425,23.4722192 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9388493,17.3129315 C34.9459726,19.1392329 35.5196712,21.2389589 35.5196712,23.4723836 C35.5196712,30.5249863 29.801863,36.2427945 22.7492603,36.2427945 L19.701589,36.2427945",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2053151,12.3626849 C14.1198356,9.33473973 18.2146301,7.45090411 22.7488767,7.45090411 C31.5970959,7.45090411 38.7702466,14.6235068 38.7702466,23.472274 C38.7702466,32.3204932 31.5970959,39.4930959 22.7488767,39.4930959",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14789041,19.5413699 C7.43227397,18.3249315 7.85528767,17.4323288 8.39884932,16.3408219",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.08739726,26.9985205 C6.85178082,25.9053699 6.72794521,25.0412603 6.72794521,23.8774247",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7070685,35.9564384 C11.2237808,34.7619178 9.9580274,33.3087671 8.97830137,31.6649315",
    id: "Stroke-11"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.7490411,
    y1: 39.4932055,
    x2: 9.63945205,
    y2: 39.4932055,
    id: "Stroke-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.3003836,
    y1: 29.2759452,
    x2: 3.22969863,
    y2: 29.2759452,
    id: "Stroke-15"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14.041863,
    y1: 14.3206027,
    x2: 3.02213699,
    y2: 14.3206027,
    id: "Stroke-17"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.1683836,
    y1: 21.7307397,
    x2: 0.137150685,
    y2: 21.7307397,
    id: "Stroke-19"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.7472877,
    y1: 11.6437808,
    x2: 36.4190685,
    y2: 8.75720548,
    id: "Stroke-21"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.7187945,
    y1: 21.3516164,
    x2: 31.0930411,
    y2: 14.4902466,
    id: "Stroke-23"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.2873425,
    y1: 7.53819178,
    x2: 37.812274,
    y2: 9.88887671,
    id: "Stroke-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.786137,4.14213699 L19.7669589,4.14213699 C18.665589,4.14213699 17.7642192,3.24076712 17.7642192,2.13939726 C17.7642192,1.0380274 18.665589,0.136657534 19.7669589,0.136657534 L25.6875068,0.136657534 C26.7888767,0.136657534 27.6902466,1.0380274 27.6902466,2.13939726 C27.6902466,3.24076712 26.7888767,4.14213699 25.6875068,4.14213699 L24.7735342,4.14213699",
    id: "Stroke-27"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.6811507,
    y1: 4.22936986,
    x2: 20.6811507,
    y2: 7.53841096,
    id: "Stroke-29"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.7733699,
    y1: 4.22936986,
    x2: 24.7733699,
    y2: 7.53841096,
    id: "Stroke-31"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup34);
export default __webpack_public_path__ + "static/media/Group-34.d7dbec93bd89552ed8421641a6e12190.svg";
export { ForwardRef as ReactComponent };